module.exports = __webpack_public_path__ + "static/media/android-step4.6c747aee.png";